module.exports = __webpack_public_path__ + "img/logo-green.76d77de5.png";